import defineMessages from "../../../../../../common/helpers/defineMessages";

const messages = defineMessages({
    title1: {
        id: "intro.barSorting.1.title",
    },
    title2: {
        id: "intro.barSorting.2.title",
    },
    title3: {
        id: "intro.barSorting.3.title",
    },
    description1: {
        id: "intro.barSorting.1.description",
    },
    description2: {
        id: "intro.barSorting.2.description",
    },
    description3: {
        id: "intro.barSorting.3.description",
    },
});

export default messages;
